module.exports = __webpack_public_path__ + "img/cruises-1.c5d88e50.png";